import Button from '@taglivros/oef_componentes/build/components/button'
import Card from '@taglivros/oef_componentes/build/components/card'
import React, { useState } from 'react'
import styled from 'styled-components'
import mgm from '../../../../assets/imagens/Card_MGM.png'
import ModalMgm from '../../../../components/ModalMgm/ModalMgm'
import { OpcionaisProvider } from '../../../../contexts/OpcionaisContext'
import { string } from 'prop-types'

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 18px;

  button {
    padding: 0;
    margin: 0;
    width: auto;
    text-decoration: underline;
  }
`

const Titulo = styled.h2`
`

const CardMGM = ( { codigoIndicacao } ) => {
  const [ showModal, setShowModal ] = useState( false )
  const toggleModal = () => setShowModal( !showModal )

  return (
    <Card
      className="card"
      largura="100%"
    >
      <HeaderWrapper>
        <Titulo>
          Indicação de amigos
        </Titulo>

        <Button
          invertido
          noBackground
          onClick={ toggleModal }
        >
          indicar
        </Button>
      </HeaderWrapper>

      <img
        alt="mgm"
        onClick={ toggleModal }
        src={ mgm }
        width="100%"
      />

      <OpcionaisProvider>
        <ModalMgm
          codigoIndicacao={ codigoIndicacao }
          showModal={ showModal }
          toggleModal={ toggleModal }
        />
      </OpcionaisProvider>
    </Card>
  )
}

CardMGM.propTypes = {
  'codigoIndicacao': string.isRequired
}


export default CardMGM
